exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2NkSOgcUn7Xcve{margin-top:8px;margin-bottom:8px}._2NkSOgcUn7Xcve:last-child{margin-bottom:0}._2RfGKd4tIw-XUP{text-decoration:none}._1FoQzNHcvCPp1q{margin-top:0;margin-bottom:0}._3WNLfRSLnnkkmi{width:100%;margin-bottom:8px;min-height:72px;background-color:#fff;border-radius:3px;box-sizing:border-box;box-shadow:0 1px 0 0 rgba(9,30,66,.25);display:block;padding-bottom:6px;position:relative;overflow:hidden}.F3X6m84g4ieEPZ{padding:8px 8px 0}._1lfupGZ_Pw3Omh{background-color:#fff;border:1px solid #0000;box-shadow:none;padding:0;overflow:hidden;overflow-wrap:break-word;resize:none;height:60px}._1lfupGZ_Pw3Omh:focus,._1lfupGZ_Pw3Omh:hover{background-color:#fff;border:1px solid transparent;box-shadow:none}", ""]);

// exports
exports.locals = {
	"createCardButton": "_2NkSOgcUn7Xcve",
	"editTemplateLink": "_2RfGKd4tIw-XUP",
	"editTemplateButton": "_1FoQzNHcvCPp1q",
	"templateCard": "_3WNLfRSLnnkkmi",
	"templateCardNameContainer": "F3X6m84g4ieEPZ",
	"templateCardEditTitle": "_1lfupGZ_Pw3Omh"
};